import type { Permissions } from '@/context/auth/types';

export const PERMISSIONS = {
  ORDER: {
    CREATE: 'order.create',
    EDIT: 'order.edit',
    UPDATE: 'order.update',
    VIEW: 'order.view',
    VIEW_DELIVERY_STATUS: 'order.viewdeliverystatus',
    DOWNLOAD_PAYLOAD: 'order.download-payload',
  },
  PRODUCT: {
    CREATE: 'product.create',
    EDIT: 'product.edit',
    VIEW: 'product.view',
  },
  ORG: {
    CREATE: 'org.create',
    EDIT: 'org.edit',
    VIEW: 'org.view',
  },
  USER: {
    CREATE: 'user.create',
  },
} as const;

export const ORDER_CREATE_PERMISSION_PREFIXES: Permissions[] = [PERMISSIONS.ORDER.CREATE];
export const ORDER_UPDATE_PERMISSION_PREFIXES: Permissions[] = [
  PERMISSIONS.ORDER.UPDATE,
  PERMISSIONS.ORDER.EDIT,
];
export const ORDER_DOWNLOAD_PAYLOAD_PERMISSION_PREFIXES: Permissions[] = [
  PERMISSIONS.ORDER.DOWNLOAD_PAYLOAD,
];
export const ORDER_VIEW_DELIVERY_STATUS_PERMISSION_PREFIXES: Permissions[] = [
  PERMISSIONS.ORDER.VIEW_DELIVERY_STATUS,
];
